<template>
  <RevButton
    :class="classes"
    data-test-styled-apple-pay
    :size
    variant="primary"
  />
</template>

<script setup lang="ts">
import { computed, useCssModule } from 'vue'

import { RevButton } from '@ds/components/Button'
import { type Sizes, SizesEnum } from '@ds/components/Button/Button.constant'

import type { PaymentSubmitButtonActionType } from '../../../types/PaymentSubmitButtonActionType'
import type { PaymentSubmitButtonVariant } from '../../../types/PaymentSubmitButtonVariant'

const props = withDefaults(
  defineProps<{
    actionType?: PaymentSubmitButtonActionType
    variant?: PaymentSubmitButtonVariant
    size?: Sizes
  }>(),
  {
    actionType: undefined,
    variant: 'primary',
    size: undefined,
  },
)

const cssModule = useCssModule()

const classes = computed(() => [
  cssModule.applePayButton,
  cssModule[props.actionType ?? 'buy'],
  props.variant === 'secondary' ? cssModule.secondary : null,
  props.size === SizesEnum.Small ? cssModule.small : null,
])
</script>

<style module>
.applePayButton {
  -webkit-appearance: -apple-pay-button;
  -apple-pay-button-style: black;
  height: 48px;
}

.small {
  height: 32px;
}

.secondary {
  -apple-pay-button-style: white-outline;
}

.buy {
  -apple-pay-button-type: buy;
}

.continue {
  -apple-pay-button-type: check-out;
}
</style>
